module.exports = __webpack_public_path__ + "static/media/Ming Chin.1c5b8ea5.jpg";